import type {
  EventListResponse,
  Feature,
  LunarEvent,
  PhenomenonType,
  Source,
  Stats,
} from "../types";

export interface AnomalyQuery {
  q?: string;
  type?: string;
  featureId?: string;
  yearFrom?: number;
  yearTo?: number;
  hasCoords?: boolean;
  page?: number;
  pageSize?: number;
}

function qs(params: AnomalyQuery): string {
  const search = new URLSearchParams();
  if (params.q) search.set("q", params.q);
  if (params.type) search.set("type", params.type);
  if (params.featureId) search.set("featureId", params.featureId);
  if (params.yearFrom != null) search.set("yearFrom", String(params.yearFrom));
  if (params.yearTo != null) search.set("yearTo", String(params.yearTo));
  if (params.hasCoords) search.set("hasCoords", "true");
  if (params.page) search.set("page", String(params.page));
  if (params.pageSize) search.set("pageSize", String(params.pageSize));
  const value = search.toString();
  return value ? `?${value}` : "";
}

async function getJson<T>(path: string): Promise<T> {
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${path}`);
  }
  return (await response.json()) as T;
}

export function fetchAnomalies(params: AnomalyQuery = {}) {
  return getJson<EventListResponse>(`/api/anomalies${qs(params)}`);
}

export function fetchAnomaly(id: string) {
  return getJson<LunarEvent>(`/api/anomalies/${encodeURIComponent(id)}`);
}

export function fetchFeatures() {
  return getJson<Feature[]>("/api/features");
}

export function fetchSources() {
  return getJson<Source[]>("/api/sources");
}

export function fetchTypes() {
  return getJson<PhenomenonType[]>("/api/types");
}

export function fetchStats() {
  return getJson<Stats>("/api/stats");
}
